/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-unused-styles */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet } from 'react-native';
import { useTheme } from 'react-native-paper';
import { Button, Dialog, Portal } from 'react-native-paper';
import { useTranslation } from 'react-i18next';

const BaseModal = ({
  visible,
  onDismiss,
  children,
  actions,
  width,
  showDefaultActions,
  cancelText,
  confirmText,
  onCancel,
  onConfirm,
  cancelButtonStyle,
  confirmButtonStyle,
  ...dialogProps
}) => {
  const theme = useTheme();
  const styles = useMemo(() => createStyles(theme, width), [theme, width]);
  const { t } = useTranslation();

  const renderActions = () => {
    if (actions) {
      return <Dialog.Actions>{actions}</Dialog.Actions>;
    }

    if (showDefaultActions) {
      return (
        <Dialog.Actions>
          <Button
            onPress={onCancel || onDismiss}
            labelStyle={{ color: theme.colors.text }}
            style={cancelButtonStyle}
          >
            {cancelText || t('cancel')}
          </Button>
          <Button onPress={onConfirm} style={confirmButtonStyle}>
            {confirmText || t('confirm')}
          </Button>
        </Dialog.Actions>
      );
    }

    return null;
  };

  return (
    <Portal>
      <Dialog
        visible={visible}
        onDismiss={onDismiss}
        style={styles.dialogContainer}
        {...dialogProps}
      >
        <Dialog.Content>{children}</Dialog.Content>
        {renderActions()}
      </Dialog>
    </Portal>
  );
};

BaseModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  actions: PropTypes.node,
  width: PropTypes.number,
  showDefaultActions: PropTypes.bool,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  cancelButtonStyle: PropTypes.object,
  confirmButtonStyle: PropTypes.object,
};

BaseModal.defaultProps = {
  actions: null,
  width: 350,
  showDefaultActions: false,
  cancelText: '',
  confirmText: '',
  onCancel: null,
  onConfirm: () => {},
  cancelButtonStyle: {},
  confirmButtonStyle: {},
};

const createStyles = (theme, width) =>
  StyleSheet.create({
    dialogContainer: {
      alignSelf: 'center',
      width: width || 350,
      maxWidth: width || 350,
      borderRadius: 8,
      backgroundColor: theme.colors.background,
    },
  });

export default BaseModal;
